import { baseReducer } from '../../../store/core/base-reducer';
import * as Actions from './scan-to-verify.actions';

const initialState = {
  shipment: {
    verificationStatus: {
      isVerified: false,
    },
  },
};

const actionHandlerMap = {
  [Actions.SET_VERIFICATION_STATUS_SUCCESS]: (state, { verificationStatus }) => {
    const { shipment } = state;
    return {
      ...state,
      shipment: {
        ...shipment,
        verificationStatus,
      },
    };
  },
};

export const scanToVerifyReducer = baseReducer(initialState, actionHandlerMap);

export { namespace } from './scan-to-verify.reducer.metadata';
